import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { getUserTenancy, tenancies } from "@/core/types/TenantTypes";
import bviReportIndex from "../components/reportIndex/bviReportIndex.vue";
import jpReportIndex from "../components/reportIndex/jpReportIndex.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ReportIndex',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_unref(getUserTenancy)() == _unref(tenancies).jp)
    ? (_openBlock(), _createBlock(jpReportIndex, { key: 0 }))
    : (_openBlock(), _createBlock(bviReportIndex, { key: 1 }))
}
}

})